import styled from "styled-components";
import { hw, scrollbar } from "../homeworkUi";

interface BatchTextInputTableProps {
    items: {
        label: string,
        name: string,
    }[];
    onChangeHandler: (name:string, value: string) => void;
}

const BatchTextInputTable = ({ items, onChangeHandler }: BatchTextInputTableProps) => {
    const renderInputWrap = () => {
        if (!items.length) {
            return null;
        }
        return items.map((item, index) => {
            return <InputWrap key={index + 1}>
                <Label>{item.label}</Label>
                <TextArea name={item.name} onChange={(e) => onChangeHandler(e.target.name, e.target.value)} placeholder="엔터로 한 줄씩 구분해 주세요"></TextArea>
            </InputWrap>
        })
    }
    return (
        <Table>
            {renderInputWrap()}
        </Table>
    );
}

const Table = styled.div`
    display: flex;
    width: 100%;
    min-height: 240px;
    flex: 1;
    border: 1px solid ${hw.border};
    border-radius: 12px;
    overflow: hidden;
    background: ${hw.surface};
`;

const InputWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
    border-right: 1px solid ${hw.border};

    &:last-child{
        border-right: none;
    }
`;

const Label = styled.div`
    padding: 10px 12px;
    background: #FAFBFC;
    text-align: center;
    border-bottom: 1px solid ${hw.border};
    color: ${hw.textMuted};
    font-size: 12px;
    font-weight: 700;
`;

const TextArea = styled.textarea`
    padding: 12px;
    flex-grow: 1;
    border: none;
    resize: none;
    font-size: 13px;
    line-height: 1.55;
    color: ${hw.text};
    background: ${hw.surface};
    ${scrollbar}

    &:focus {
        outline: none;
        background: #FFFBFA;
    }

    &::placeholder {
        color: ${hw.textSubtle};
    }
`;

export default BatchTextInputTable;
